// extracted by mini-css-extract-plugin
module.exports = {"akbankContainer":"styles_akbankContainer__94kyP","akbankText":"styles_akbankText__4kB0q","divider":"styles_divider__64IHC","creditText":"styles_creditText__QGBR1","rightIcon":"styles_rightIcon__0geuI"};
module.exports.__checksum = "e2d3dd4c4512"
